import { render } from "./LKFLink.vue?vue&type=template&id=41181eb2&ts=true"
import script from "./LKFLink.vue?vue&type=script&lang=ts"
export * from "./LKFLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__